import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const produtoService = {
  findAllByCnpjAndCodigo,
  findAll,
  buscarPorCodigoDepositante,
  buscarPorCliente,
  buscarProdutosPaginado,
  doGet,
};
async function findAllByCnpjAndCodigo(produtos, cnpj) {
  let retorno = [];
  for (let i in produtos) {
    let produto = produtos[i];
    let produtoDB = await defaultService.doGet(
      `${urlsConstants.API_PRODUTO}findByClienteAndCodigo/${cnpj}/${produto.prod.cprod}`
    );
    retorno.push(produtoDB.data);
  }
  return retorno;
}
function findAll(parent) {
  if (parent) {
    console.log(parent.codigoDepositante);
    return defaultService.doGet(
      `${urlsConstants.API_PRODUTO}findByCodigoDepositante/${parent.codigoDepositante}`
    );
  }
  console.log('findAll');

  return defaultService.doGet(`${urlsConstants.API_PRODUTO}findAll`);
}

function buscarPorCodigoDepositante(codigoDepositante, termo) {
  return defaultService.doGet(
    `${urlsConstants.API_PRODUTO}buscarPorCodigoDepositante/${codigoDepositante}?termo=${encodeURIComponent(termo)}`,
  );
}

function buscarPorCliente(termo, cliente, page = 0, size = 50) {
  const codigoDepositante =
    cliente && cliente.codigoDepositante
      ? cliente.codigoDepositante
      : typeof cliente === 'string'
      ? cliente
      : null;

  return buscarProdutosPaginado(codigoDepositante, termo, page, size);
}

function buscarProdutosPaginado(
  codigoDepositante,
  termo,
  page = 0,
  size = 50,
) {
  if (
    !codigoDepositante ||
    !termo ||
    String(termo).trim().length < 3
  ) {
    return Promise.resolve({ data: { content: [] } });
  }

  const pagina = Math.max(Number(page) || 0, 0);
  const tamanho = Math.min(Math.max(Number(size) || 50, 1), 50);

  return defaultService.doGet(
    `${urlsConstants.API_PRODUTO}buscarPorCodigoDepositantePaginado/${encodeURIComponent(
      codigoDepositante,
    )}?termo=${encodeURIComponent(String(termo).trim())}&page=${pagina}&size=${tamanho}`,
  );
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.API_PRODUTO}${id}`);
}
